import React, { useContext } from 'react'
import { motion } from 'framer-motion/dist/framer-motion'

import { DataContext } from '../../../Context/DataContext'
import { UIContext } from '../../../Context/UIContext'

import usePreloadImage from '../../../usePreloadImage'

const PartnerCard = React.forwardRef(({data}, ref) => {
    const { strings } = useContext(DataContext)
    const { setModalVisible, setSelectedModal } = useContext(UIContext)
    const imageLoaded = usePreloadImage(data.logo)

    const handleSelectPartner = () => {
        const modalData = {
            title: data.title,
            image: data.logo,
            url: data.url,
            info: data.info
        }
        setSelectedModal(modalData)
        setModalVisible(true)
    }
    return (
        <motion.div
            className="mga-membercard mga-membercard--partner"
        >
            <figure
                className={`mga-membercard__image${!imageLoaded ? ' mga-img-loading' : ''}`}
                onClick={handleSelectPartner}    
            >
                { imageLoaded && <img src={data.logo} alt={data.title} /> }
            </figure>
            <div
                className="mga-membercard__info"
            >
                <h3>{ data.title }</h3>
            </div>
            <button
                className="mga-membercard__info__more"
                onClick={handleSelectPartner}
            >{ strings.more }</button>
        </motion.div>
    )
})
const MotionPartnerCard = motion(PartnerCard)

export default MotionPartnerCard